import { FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation } from 'react-i18next';

import useUtilities from '../../hooks/useUtilities';
import { requiredColorCode } from '../../Styles/componentStyles';
import { CompareTwoString } from '../../Utils/utils';
// import { CompareTwoString } from '../../Utils/utils';

function SelectRadioBtn({value, setValue, name,options, setCheckUpdateValue,disabled=false}) {
    SelectRadioBtn.propTypes = {
        value: PropTypes.any,
        name: PropTypes.any,
        setValue: PropTypes.func.isRequired,
        disabled:PropTypes.any,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                optionValue: PropTypes.string.isRequired,
            })
        ).isRequired,
        setCheckUpdateValue: PropTypes.func,
    };
    const { errors, showErrors } =useUtilities();
    const error = name in errors ? errors[name] : undefined;
    const { i18n } = useTranslation();
    return (
        <FormControl
            error={!!error && showErrors}
            style={{ color: showErrors && (error ?? '') ? requiredColorCode : 'inherit' }}
            disabled={disabled}
        >
            <RadioGroup
                row
                name={name}
                value={value}
                onChange={e => {
                    if (!CompareTwoString(e.target.value, value) && setCheckUpdateValue) {
                        setCheckUpdateValue(false);
                    }
                    setValue(e.target.value);
                }}
            >
                {options.map((option) => (
                    <FormControlLabel
                        key={option.optionValue}
                        value={option.optionValue}
                        control={
                            <Radio
                                sx={{
                                    color: showErrors && (error ?? '') ? requiredColorCode : 'inherit',
                                    '&.Mui-checked': {
                                        color: showErrors && (error ?? '') ? requiredColorCode : 'inherit',
                                    },
                                }}
                            />
                        }
                        style={{
                            fontFamily: 'Lato',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            fontSize: '16px',
                            lineHeight: '24px',
                            letterSpacing: '-0.0044em',
                            color: '#475063',
                        }}
                        label={i18n.t(option.label)}
                    />
                ))}
            </RadioGroup>
            <FormHelperText>{showErrors && (error ?? '')}</FormHelperText>
        </FormControl>
    );
}

SelectRadioBtn.propTypes = {};

export default SelectRadioBtn;
